
/* ===== Page: Solutions – Fibre-Optic Perimeter ===== */
import React from 'react';
import MainLayout from '@/components/Layout/MainLayout';
import {
  FibreHero,
  FibreOverview,
  FibreInstallation,
  FibreBenefits,
  FibreTestimonials,
  FibreFAQ,
  FibreCTA
} from '@/components/Solutions/Fibre';

const SolutionsFibre = () => {
  return (
    <MainLayout>
      <FibreHero />
      <FibreOverview />
      <FibreInstallation />
      <FibreBenefits />
      <FibreTestimonials />
      <FibreFAQ />
      <FibreCTA />
    </MainLayout>
  );
};

export default SolutionsFibre;
